export default "__VITE_ASSET__BBtnJq2P__"